// extracted by mini-css-extract-plugin
export default {"asideCefX":"styles_asideCefX__fzlnu","tiposDePontos":"styles_tiposDePontos__tuhz5","wrapper_tiposDePontos":"styles_wrapper_tiposDePontos__UAflT","point":"styles_point__U2GLe"};